import type { SlideHandle } from 'nuka-carousel';
import { ReactNode, useCallback, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { validationMessages } from '../messages';
import { Headline } from '../styles';
import validationCards from './data';
import {
	Carousel,
	ChevronRight,
	GridWrapper,
	QuotesWrapper,
	Section,
	StatHighlight,
	StatSourceDetail,
	StatsWrapper,
	StatText,
} from './styles';
import Testimonial from './testimonial';

const Testimonials = () => {
	const statsKeys = Object.keys(validationCards);
	const { formatMessage } = useIntl();

	const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
	const carouselRef = useRef<SlideHandle>(null);

	const onDrag = useCallback(
		(slideIndex: number) => {
			// As this callback happens after an animation, we need to make sure that we ignore "old" updates
			setCurrentSlideIndex(_slide => (_slide !== currentSlideIndex ? _slide : slideIndex));
		},
		[currentSlideIndex],
	);

	const goToSlide = useCallback((slideIndex: number) => {
		setCurrentSlideIndex(slideIndex);
		carouselRef.current?.goToPage(slideIndex);
	}, []);

	return (
		<Section>
			<GridWrapper>
				<Headline $span>{formatMessage(validationMessages.validationHeadline)}</Headline>
				<StatsWrapper>
					{statsKeys.map((key, idx) => (
						<StatText key={key} $isActive={idx === currentSlideIndex} onClick={() => goToSlide(idx)}>
							{formatMessage(validationCards[key].stat, {
								stat: (chunks: ReactNode) => <StatHighlight>{chunks}</StatHighlight>,
							})}
							<ChevronRight $isActive={currentSlideIndex === idx} />
						</StatText>
					))}
					<StatSourceDetail>{formatMessage(validationMessages.validationSourceDetail)}</StatSourceDetail>
				</StatsWrapper>
				<QuotesWrapper>
					<Carousel ref={carouselRef} showDots afterSlide={onDrag} wrapMode="wrap">
						{Object.entries(validationCards).map(([title, stat]) => (
							<Testimonial key={title} {...stat} />
						))}
					</Carousel>
				</QuotesWrapper>
			</GridWrapper>
		</Section>
	);
};

export default Testimonials;
